<template>
  <BlSheetChildPage id="sheet-sort" style="margin: 0 auto" class="max-w-[480px]" title="Urutkan berdasarkan" auto-height @close="onClose">
    <div style="padding: 0px 16px 2px">
      <div v-for="(sortOption, index) in getSortCourseOptions" :key="sortOption.value" class="block pv-4">
        <BlRadioAv :id="`ut-radio-${index + 1}`" v-model="sortBy" :native-value="sortOption.value" class="u-width-1 pv-4">
          {{ sortOption.name }}
        </BlRadioAv>
      </div>
      <div class="block mv-16">
        <BlButtonAv id="ut-sort-trigger" variation="primary" fullwidth @click="onSubmit">Terapkan</BlButtonAv>
      </div>
    </div>
  </BlSheetChildPage>
</template>

<script>
import BlSheetChildPage from '../shared/BlSheetChildPage.vue';
import {mapGetters} from 'vuex';
import {BlRadioAv, BlButtonAv} from '@bukalapak/bazaar-mweb-latest';
import prakerjaFilterMixin from '../../mixins/prakerja-filter-mixin';

export default {
  name: 'PrakerjaCoursesSort',
  components: {BlSheetChildPage, BlRadioAv, BlButtonAv},
  mixins: [prakerjaFilterMixin],
  data() {
    return {
      sortBy: 'name',
    };
  },
  computed: {
    ...mapGetters('courses', ['getSortCourseOptions', 'getSortCoursesBy']),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.sortBy = this.getSortCoursesBy;
    },
    onSubmit() {
      this.$store.commit('courses/setSortCoursesBy', this.sortBy);
      this.$store.commit('courses/resetCourses');
      this.$store.dispatch('courses/fetchCourses');

      this.onClose();
    },
  },
};
</script>
